import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import styles from "./Services.module.css";

const services = [
  {
    icon: "📦",
    title: "Logistics Consulting",
    description:
      "In-depth analysis of your logistics operations, helping identify inefficiencies in warehouse flows, inventory management, and overall supply chain strategy.",
  },
  {
    icon: "📊",
    title: "Data Analytics & Reporting",
    description:
      "Advanced analytics using tools like SQL, Python, and Power BI to uncover insights, trends, and key metrics for smarter decision-making.",
  },
  {
    icon: "💻",
    title: "Web Development",
    description:
      "Full-stack development of modern web applications, internal tools, dashboards, and systems tailored to your business needs using React, Node.js and more.",
  },
];

const Services = () => {
  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >

      <div className={styles.grid}>
        {services.map((service, index) => (
          <motion.div
            key={index}
            className={styles.card}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className={styles.icon}>{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </div>

      <div className={styles.calcCta}>
        <p>Curious what better routing and fuller trucks could save you?</p>
        <Link to="/savings-calculator" className={styles.calcLink}>
          Try the Transport Savings Calculator →
        </Link>
      </div>
    </motion.div>
  );
};

export default Services;
